import React, { forwardRef, useRef } from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'

const style = (props) => ({
	transition: `opacity ${props.timeout}ms ease-in-out`,
	opacity: 0,
	zIndex: props.zIndex
})

const transitionStyles = {
	entering: { opacity: 1 },
	entered: { opacity: 1 },
	exiting: { opacity: 0 },
	exited: { opacity: 0 }
}

const Fade = forwardRef(function Fade(props, ref) {
	const { appear = true, in: inProp, children, timeout = 100, zIndex, ...other } = props

	const transitionRef = useRef(null)

	return (
		<Transition ref={ref} appear={appear} in={inProp} nodeRef={transitionRef} timeout={timeout} {...other}>
			{(state) => (
				<div
					style={{
						...style(props),
						...transitionStyles[state]
					}}
				>
					{children}
				</div>
			)}
		</Transition>
	)
})

export default Fade

Fade.defaultProps = {
	appear: true,
	timeout: 100,
}

Fade.propTypes = {
	/**
	 * Perform the enter transition when it first mounts if `in` is also `true`.
	 * Set this to `false` to disable this behavior.
	 * @default true
	 */
	appear: PropTypes.bool,
	/**
	 * A single child content element.
	 */
	children: PropTypes.node,
	/**
	 * If `true`, the component will transition in.
	 */
	in: PropTypes.bool,
	/**
	 * The duration for the transition, in milliseconds.
	 * You may specify a single timeout for all transitions, or individually with an object.
	 * @default 100
	 */
	timeout: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.shape({
			appear: PropTypes.number,
			enter: PropTypes.number,
			exit: PropTypes.number
		})
	]),
	/**
	 * The z-index of the element.
	 */
	zIndex: PropTypes.number
}
